import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetSbatGroupListQuery } from 'features/classCreation';
import BulkActions from './BulkActions';
import BulkAddSuperBatchesModal from './BulkAddSuperBatchesModal';
import BulkDeleteSbatGroupsModal from './BulkDeleteSbatGroupsModal';
import BulkRemoveSuperBatchesModal from './BulkRemoveSuperBatchesModal';
import BulkUpdateInstructorsModal from './BulkUpdateInstructorsModal';
import CompletedClassesAccordion from './CompletedClassesAccordion';
import DeleteClassModal from './DeleteClassModal';
import ErrorLayout from 'components/ErrorLayout';
import Field from 'components/Field';
import FilterDrawer from './FilterDrawer';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import UpcomingClassesFilters from './UpcomingClassesFilters';
import UpcomingClassesTable from './UpcomingClassesTable';

export default function ViewSchedulePage() {
  const { superBatchId } = useParams();
  const { isLoading, isFetching, error, data, refetch } =
    useGetSbatGroupListQuery(Number(superBatchId));

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load classes"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const sbatGroups = data.data;

    return (
      <div className="m-t-m">
        <GlobalLoader isVisible={isFetching} />
        <DeleteClassModal />
        <BulkAddSuperBatchesModal />
        <BulkRemoveSuperBatchesModal />
        <BulkUpdateInstructorsModal />
        <BulkDeleteSbatGroupsModal />
        <UpcomingClassesFilters />
        <Field label="Upcoming Classes">
          <UpcomingClassesTable sbatGroups={sbatGroups} />
        </Field>
        <Field label="Bulk Actions">
          <BulkActions />
        </Field>
        <CompletedClassesAccordion sbatGroups={sbatGroups} />
        <FilterDrawer />
      </div>
    );
  }
}
